import classNames from 'classnames';
import { ButtonHTMLAttributes, ReactNode } from 'react';
import { Loader } from 'rsuite';
import styles from './SecondaryButton.module.scss';

export type SecondaryButtonProps = {
  icon?: ReactNode;
  skin?: 'blue' | 'red' | 'gray';
  isLoading?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const SecondaryButton = ({ className, children, icon, skin = 'gray', isLoading = false, disabled, ...props }: SecondaryButtonProps) => (
  <button
    className={classNames(styles['info-secondary-button'], styles[`info-secondary-button-${skin}`], className)}
    disabled={isLoading || disabled}
    {...props}
  >
    {isLoading ? (
      <span className={styles['info-secondary-button__content_loading']}>
        <Loader size="sm" />
      </span>
    ) : (
      <>
        {icon && <span className={styles['info-secondary-button__icon__container']}>{icon}</span>}
        {children && <span className={styles['info-secondary-button__content']}>{children}</span>}
      </>
    )}
  </button>
);

export { SecondaryButton };
